export interface HorariosClubesStore {
  configuraciones: any[];
  mantenimientos: any[];
  clubes: any[];
  searching: boolean;
  saving: boolean;
  updating: boolean;
  deleting: boolean;
}

export const horariosClubesStore: (state) => HorariosClubesStore = state => {
  const horariosClubesState = state.horariosClubesReducer || {};

  return {
    configuraciones: horariosClubesState.configuraciones || [],
    mantenimientos: horariosClubesState.mantenimientos || [],
    clubes: horariosClubesState.clubes || [],
    searching: horariosClubesState.searching || false,
    saving: horariosClubesState.saving || false,
    updating: horariosClubesState.updating || false,
    deleting: horariosClubesState.deleting || false
  };
};
